import { useQuery } from '@gogame/query';

import { loadModel } from 'scenes/CountryGroups/sources/countryGroups';

import { model } from './queryKeyFactory';

export const useLoadCG = (id) => {
  return useQuery(model(id), (_, { signal }) => loadModel({ id }, { signal }));
};
